/**
 * KAYIP ŞERİDİ VERİSİ — ortak kanca.
 *
 * `KayipSeridi.jsx`ten ÇIKARILDI (6 Eyl 2026), KOPYALANMADI.
 *
 * Sebep: Benim Mahallem panoda kayıp kedileri BAŞKA bir düzende gösteriyor
 * (fotoğrafı üstte kartlar), ama `KayipSeridi` kendi başlığını da çiziyor —
 * onu kartın içine koymak ekranda İKİ BAŞLIK demekti. Düzeni ayırmanın
 * bedeli ikinci bir veri çekimi olmamalı: iki ekran da bu kancayı kullanıyor,
 * yani tek istek, tek önbellek, tek yeniden deneme mantığı.
 *
 * `haritaRenkleri.js` ve `isiBolgeleri.js`te aynı karar verilmişti:
 * paylaşılan şey HESAP/VERİ, görünüm değil.
 *
 * Davranış birebir korundu — dayanıklılık notu dahil: istek TEK seferlikti ve
 * backend deploy sonrası yeniden başlarken şerit SONSUZA DEK boş kalıyordu
 * ("ana sayfadaki kayıp ilanlar kayboldu" olayının kök nedeni). 15 sn arayla
 * en çok 8 deneme + sekme öne gelince tazeleme, buradan geliyor.
 */
import { useEffect, useState } from "react";
import { apiClient } from "../auth";
import { animalParam } from "../animalMode";

const KS_CACHE = "sk_kayip_seridi_v1";
function cachedIlanlar() {
  try {
    const raw = localStorage.getItem(KS_CACHE);
    const v = raw ? JSON.parse(raw) : null;
    return Array.isArray(v) ? v : [];
  } catch { return []; }
}

/** Açık kayıp ilanları — en yeniden eskiye, en çok 10. */
export function useKayipIlanlari() {
  const [ilanlar, setIlanlar] = useState(cachedIlanlar);

  useEffect(() => {
    let iptal = false;
    let denemeTimer = null;
    // KÖPEK-3b: seçili türe göre süz; mod değişince (sk-animal-mode) yenile.
    //
    // DAYANIKLILIK (22 Ağu 2026): istek TEK seferlikti; backend deploy sonrası
    // yeniden başlarken (CLIP yüklemesi ~dk sürer) zaman aşımına düşünce catch
    // sessizce yutuyor ve şerit SONSUZA DEK boş kalıyordu — "ana sayfadaki
    // kayıp ilanlar kayboldu" olayının kök nedeni. Artık başarısız istek
    // 15 sn arayla (en çok 8 kez) yeniden denenir; sekme öne gelince de
    // tazelenir. Veri hep sunucudaydı; şerit pes ediyordu.
    let kalanDeneme = 8;
    const yukle = () => {
      const ap = animalParam();
      apiClient()
        .get("/sightings", { params: { status_: "open", ...(ap ? { animal: ap } : {}) } })
        .then((r) => {
          if (iptal) return;
          const kayiplar = (Array.isArray(r.data) ? r.data : [])
            .filter((s) => s.category === "lost" && s.status === "open")
            .sort((a, b) => (b.created_at || "").localeCompare(a.created_at || ""))
            .slice(0, 10);
          setIlanlar(kayiplar);
          // Bir dahaki açılış ANINDA göstersin diye sakla. Fotoğraflar artık
          // küçük R2 URL'leri olduğu için önbellek de hafif (KB mertebesi).
          try { localStorage.setItem(KS_CACHE, JSON.stringify(kayiplar)); } catch { /* dolu/kapalı olabilir */ }
        })
        .catch(() => {
          if (iptal || kalanDeneme <= 0) return;
          kalanDeneme -= 1;
          denemeTimer = setTimeout(yukle, 15000);
        });
    };
    const gorunurse = () => { if (document.visibilityState === "visible") yukle(); };
    yukle();
    window.addEventListener("sk-animal-mode", yukle);
    document.addEventListener("visibilitychange", gorunurse);
    return () => {
      iptal = true;
      if (denemeTimer) clearTimeout(denemeTimer);
      window.removeEventListener("sk-animal-mode", yukle);
      document.removeEventListener("visibilitychange", gorunurse);
    };
  }, []);

  return ilanlar;
}
